// src/pages/Commissions/CommissionCard.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import Modal from "./ActeurCommissionModal"; // ou "../Modal/Modal" selon ton arborescence
import {
  FaUsers,
  FaNewspaper,
  FaUserTie,
  FaChevronRight,
} from "react-icons/fa";

const CommissionCard = ({ group, articleCount = 0 }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const responsables = (group.Acteurs || []).filter(
    (acteur) => acteur.ActeurGroup?.is_responsable
  );
  const responsableText =
    responsables.length > 1 ? "Co-responsable(s)" : "Responsable";

  const photoUrl = group.photo_url || "/img/default_image.jpg";

  return (
    <>
      <article className="group flex flex-col bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-lg border border-slate-200/80 dark:border-slate-700/80 overflow-hidden transition-all duration-200 hover:shadow-xl hover:-translate-y-0.5">
        {/* Image + badge articles */}
        <div className="relative h-40 sm:h-44 md:h-48 overflow-hidden">
          <img
            src={photoUrl}
            alt={group.nom}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
          <div className="absolute top-3 left-3">
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-[0.18em] bg-primary/90 text-white">
              Commission
            </span>
          </div>
          <div className="absolute top-3 right-3">
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[11px] font-semibold bg-white/90 dark:bg-slate-900/90 text-slate-800 dark:text-slate-100">
              <FaNewspaper className="text-xs" />
              {articleCount} article{articleCount > 1 && "s"}
            </span>
          </div>
        </div>

        {/* Contenu */}
        <div className="flex flex-col flex-1 p-4 sm:p-5">
          {/* Titre */}
          <h3 className="text-base sm:text-lg md:text-xl font-bold text-slate-800 dark:text-white font-montserrat mb-2">
            {group.nom}
          </h3>

          {/* Description */}
          <div
            className="text-sm text-slate-700 dark:text-slate-200 mb-4 line-clamp-4"
            dangerouslySetInnerHTML={{
              __html: group.description || "Pas de description disponible",
            }}
          />

          {/* Responsables */}
          <div className="mt-auto">
            <div className="rounded-xl bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 p-3 mb-3">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-300 mb-2 flex items-center gap-2">
                <FaUserTie className="text-slate-400" />
                {responsableText}
              </p>
              <div className="flex flex-wrap gap-3">
                {responsables.length === 0 && (
                  <p className="text-xs text-slate-500 dark:text-slate-300">
                    Non renseigné.
                  </p>
                )}
                {responsables.map((acteur) => (
                  <div
                    key={acteur.id}
                    className="flex items-center gap-2 text-xs"
                  >
                    <img
                      src={acteur.photo_url || "/img/user_avatar.jpg"}
                      alt={`${acteur.prenom} ${acteur.nom}`}
                      className="w-9 h-9 rounded-full object-cover border border-white shadow dark:border-slate-700"
                    />
                    <div className="flex flex-col">
                      <span className="font-semibold text-slate-800 dark:text-slate-100">
                        {acteur.prenom} {acteur.nom}
                      </span>
                      {acteur.ActeurGroup?.poste && (
                        <span className="text-[11px] text-slate-500 dark:text-slate-300">
                          {acteur.ActeurGroup.poste}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <button
                type="button"
                onClick={handleModalOpen}
                className="mt-3 inline-flex items-center gap-2 text-[11px] font-semibold text-primary hover:text-primary/80"
              >
                <FaUsers className="text-xs" />
                Tous les membres de la Commission
              </button>
            </div>

            {/* Footer / Bouton Articles */}
            <div className="flex justify-end">
              <Link
                to={`/commission/${group.id}/articles`}
                className="inline-flex"
              >
                <Button
                  text={
                    articleCount > 0
                      ? `${articleCount} article(s) publié(s)`
                      : "Pas d'articles publiés"
                  }
                  className="gap-2 text-sm"
                  icon={FaChevronRight}
                />
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Modale membres */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={`Membres de la commission ${group.nom}`}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {(group.Acteurs || []).map((acteur) => (
            <div key={acteur.id} className="flex flex-col items-center text-center">
              <img
                src={acteur.photo_url || "/img/user_avatar.jpg"}
                alt={`${acteur.prenom} ${acteur.nom}`}
                className="w-20 h-20 rounded-full object-cover mb-2 border border-white shadow dark:border-slate-700"
              />
              <p className="text-sm font-semibold">
                {acteur.prenom} {acteur.nom}
              </p>
              {acteur.ActeurGroup?.poste && (
                <p className="text-xs text-slate-500 dark:text-slate-300">
                  {acteur.ActeurGroup.poste}
                </p>
              )}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default CommissionCard;
